import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const InvestimentoUFM = () => {
  const [investimentos, setInvestimentos] = useState([]);
  const [filteredInvestimentos, setFilteredInvestimentos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingInvestimento, setEditingInvestimento] = useState(null);
  const [formData, setFormData] = useState({
    nomeclatura: '',
    sigla: '',
    faixa: '',
    de: '',
    ate: '',
    ativo: true
  });

  useEffect(() => {
    const fetchInvestimentos = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/investimento-ufm`);
        if (!response.ok) {
          throw new Error('Erro ao buscar investimentos em UFM');
        }
        const data = await response.json();
        setInvestimentos(data);
        setFilteredInvestimentos(data);
      } catch (error) {
        console.error('Erro ao carregar investimentos em UFM:', error);
      }
    };

    fetchInvestimentos();
  }, []);

  const handleSearch = (term) => {
    setSearchTerm(term);
    const lower = term.toLowerCase();
    const filtered = investimentos.filter((item) =>
      (item.nomeclatura || '').toLowerCase().includes(lower) ||
      (item.sigla || '').toLowerCase().includes(lower) ||
      (item.faixa || '').toLowerCase().includes(lower)
    );
    setFilteredInvestimentos(filtered);
  };

  const handleNew = () => {
    setEditingInvestimento(null);
    setFormData({
      nomeclatura: '',
      sigla: '',
      faixa: '',
      de: '',
      ate: '',
      ativo: true
    });
    setShowForm(true);
  };

  const handleEdit = (investimento) => {
    setEditingInvestimento(investimento);
    setFormData({
      nomeclatura: investimento.nomeclatura,
      sigla: investimento.sigla,
      faixa: investimento.faixa,
      de: investimento.de,
      ate: investimento.ate,
      ativo: investimento.ativo
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nomeclatura.trim() || !formData.sigla.trim() || !formData.faixa.trim()) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    const payload = {
      nomeclatura: formData.nomeclatura,
      sigla: formData.sigla,
      faixa: formData.faixa,
      de: formData.de === '' ? null : parseInt(formData.de, 10),
      ate: formData.ate === '' ? null : parseInt(formData.ate, 10),
      ativo: formData.ativo
    };

    try {
      if (editingInvestimento) {
        const response = await fetch(
          `${API_BASE_URL}/investimento-ufm/${editingInvestimento.id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar investimento em UFM');
        }

        const updated = await response.json();
        setInvestimentos((prev) =>
          prev.map((item) => (item.id === editingInvestimento.id ? updated : item))
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/investimento-ufm`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar investimento em UFM');
        }

        const created = await response.json();
        setInvestimentos((prev) => [...prev, created]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar investimento em UFM:', error);
    }
  };

  const resetForm = () => {
    setFormData({
      nomeclatura: '',
      sigla: '',
      faixa: '',
      de: '',
      ate: '',
      ativo: true
    });
    setEditingInvestimento(null);
    setShowForm(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este investimento em UFM?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/investimento-ufm/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir investimento em UFM');
      }

      setInvestimentos((prev) => prev.filter((item) => item.id !== id));
      setFilteredInvestimentos((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error('Erro ao excluir investimento em UFM:', error);
    }
  };

  const handleToggleStatus = async (id) => {
    const atual = investimentos.find((i) => i.id === id);
    if (!atual) return;

    const atualizado = {
      ...atual,
      ativo: !atual.ativo
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/investimento-ufm/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(atualizado)
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do investimento em UFM');
      }

      const saved = await response.json();
      setInvestimentos((prev) =>
        prev.map((i) => (i.id === id ? saved : i))
      );
      setFilteredInvestimentos((prev) =>
        prev.map((i) => (i.id === id ? saved : i))
      );
    } catch (error) {
      console.error('Erro ao atualizar status do investimento em UFM:', error);
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Investimento em UFM</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={handleNew}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Investimento
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingInvestimento ? 'Editar Investimento em UFM' : 'Cadastrar Investimento em UFM'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nomeclatura">Nomenclatura *</label>
                <input
                  type="text"
                  id="nomeclatura"
                  value={formData.nomeclatura}
                  onChange={(e) =>
                    setFormData({ ...formData, nomeclatura: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="sigla">Sigla *</label>
                <select
                  id="sigla"
                  value={formData.sigla}
                  onChange={(e) =>
                    setFormData({ ...formData, sigla: e.target.value })
                  }
                  required
                >
                  <option value="">Selecione...</option>
                  <option value="MICRO">MICRO</option>
                  <option value="PEQUENO">PEQUENO</option>
                  <option value="MÉDIO">MÉDIO</option>
                  <option value="GRANDE">GRANDE</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="faixa">Faixa *</label>
                <select
                  id="faixa"
                  value={formData.faixa}
                  onChange={(e) =>
                    setFormData({ ...formData, faixa: e.target.value })
                  }
                  required
                >
                  <option value="">Selecione a faixa</option>
                  {Array.from({ length: 26 }, (_, i) =>
                    String.fromCharCode(65 + i)
                  ).map((letter) => (
                    <option key={letter} value={letter}>
                      {letter}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="de">De</label>
                <input
                  type="number"
                  id="de"
                  value={formData.de}
                  onChange={(e) =>
                    setFormData({ ...formData, de: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="ate">Até</label>
                <input
                  type="number"
                  id="ate"
                  value={formData.ate}
                  onChange={(e) =>
                    setFormData({ ...formData, ate: e.target.value })
                  }
                />
              </div>
              <div className="form-group">
                <Toggle
                  id="ativo"
                  label="Status:"
                  checked={formData.ativo}
                  onChange={(e) =>
                    setFormData({ ...formData, ativo: e.target.checked })
                  }
                />
              </div>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={resetForm}
              >
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editingInvestimento ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Buscar por nomenclatura, sigla ou faixa..."
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredInvestimentos.length} registro(s) encontrado(s)</span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Nomenclatura</th>
                  <th className="col-sigla">Sigla</th>
                  <th>Faixa</th>
                  <th>De</th>
                  <th>Até</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredInvestimentos.map((investimento) => (
                  <tr key={investimento.id}>
                    <td>{investimento.id}</td>
                    <td>{investimento.nomeclatura}</td>
                    <td>{investimento.sigla}</td>
                    <td>{investimento.faixa}</td>
                    <td>{investimento.de}</td>
                    <td>{investimento.ate}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={investimento.ativo}
                          onChange={() => handleToggleStatus(investimento.id)}
                          id={`toggle-investimento-${investimento.id}`}
                        />
                      </div>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => handleEdit(investimento)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(investimento.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredInvestimentos.length === 0 && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <h3>Nenhum investimento encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo investimento.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default InvestimentoUFM;
